import { put, takeLatest, delay, select, takeEvery } from 'redux-saga/effects';
import ActionTypes from '../actions/actionTypes';
import { resetToastAlert } from 'actions/toastAlertActions';

function* addToastAlert(action) {
  const { id, dismissable } = action.payload;

  if (!dismissable) {
    yield delay(10000);

    const isModalOpen = yield select((state) => state.toastAlertStore.isModalOpen);
    const currentId = yield select((state) => state.toastAlertStore.id);

    if (!isModalOpen && id === currentId) {
      yield put(resetToastAlert());
    }
  }
}

function* resetToastAlertModal() {
  const dismissable = yield select((state) => state.toastAlertStore.dismissable);

  if (!dismissable) {
    yield put(resetToastAlert());
  }
}

export default function* toastAlertSaga() {
  yield takeEvery(ActionTypes.TOAST_ALERT.ADD, addToastAlert);
  yield takeLatest(ActionTypes.TOAST_ALERT.RESET_MODAL, resetToastAlertModal);
}